/* Wuschelherz: aus snippets/wh-photo-vault.liquid ausgelagert (Perf 1, 2026-11-02). Änderungen hier, nicht im Snippet. */
  (() => {
    if (window.whVault) return;
    const DB = 'wh-vault', STORE = 'photos', MAX = 3, MAX_BYTES = 30 * 1024 * 1024;
    const OPT = 'wh-vault-optin', VISIT_MS = 3 * 60 * 60 * 1000;
    const ls = (k, v) => { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; } };
    const optedIn = () => ls(OPT) === '1';
    const autoApply = /[?&]wh_auto=1(&|$)/.test(window.location.search);
    const open = () => new Promise((res, rej) => {
      const r = indexedDB.open(DB, 1);
      r.onupgradeneeded = () => r.result.createObjectStore(STORE, { keyPath: 'id' });
      r.onsuccess = () => res(r.result); r.onerror = () => rej(r.error);
    });
    const tx = async (mode, fn) => { const db = await open(); return new Promise((res, rej) => { const t = db.transaction(STORE, mode); const s = t.objectStore(STORE); const out = fn(s); t.oncomplete = () => res(out && out.result !== undefined ? out.result : out); t.onerror = () => rej(t.error); }); };
    const expired = (p) => !p.keep && Date.now() - (p.used || p.ts) > VISIT_MS;
    const raw = async () => { try { return (await tx('readonly', (s) => s.getAll())) || []; } catch (e) { return []; } };
    const purge = async () => { const list = await raw(); const old = list.filter(expired); if (old.length) { try { await tx('readwrite', (s) => old.forEach((p) => s.delete(p.id))); } catch (e) {} } };
    const all = async () => (await raw()).filter((p) => !expired(p)).sort((a, b) => (b.used || b.ts) - (a.used || a.ts));
    const save = async (file, keep) => {
      if (!file || !file.type.startsWith('image/') || file.size > MAX_BYTES) return null;
      const list = await all();
      const same = list.find((p) => p.name === file.name && p.size === file.size);
      if (same) { await tx('readwrite', (s) => s.put({ ...same, keep: same.keep || keep, used: Date.now() })); return same.id; }
      const id = Date.now() + '-' + Math.random().toString(36).slice(2, 7);
      await tx('readwrite', (s) => s.put({ id, name: file.name, type: file.type, size: file.size, ts: Date.now(), used: Date.now(), keep: !!keep, blob: file }));
      const after = await all();
      if (after.length > MAX) await tx('readwrite', (s) => after.slice(MAX).forEach((p) => s.delete(p.id)));
      return id;
    };
    const keepAll = async () => { const list = await all(); await tx('readwrite', (s) => list.forEach((p) => s.put({ ...p, keep: true }))); };
    const clear = async () => { try { await tx('readwrite', (s) => s.clear()); } catch (e) {} ls(OPT, null); document.querySelectorAll('.wh-vault__note').forEach((n) => n.remove()); render(); };

    const inputs = () => Array.from(document.querySelectorAll('main input[type="file"]')).filter((i) => !i.accept || i.accept.includes('image') || i.accept.includes('.jp') || i.accept.includes('*'));
    const anchorOf = (input) => input.closest('label') || input.parentElement;

    const useFile = async (input, p) => {
      const file = new File([p.blob], p.name, { type: p.type, lastModified: p.ts });
      const dt = new DataTransfer(); dt.items.add(file);
      input.files = dt.files;
      input.__whFromVault = true;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      try { await tx('readwrite', (s) => s.put({ ...p, used: Date.now() })); } catch (e) {}
    };

    let usedId = null;
    const render = async () => {
      const list = await all();
      inputs().forEach((input) => {
        const anchor = anchorOf(input); if (!anchor || !anchor.parentNode) return;
        let box = anchor.parentNode.querySelector(':scope > .wh-vault[data-for]');
        if (!list.length) { if (box) box.remove(); return; }
        const sig = list.map((p) => p.id + (p.keep ? 'k' : '')).join(',') + '|' + usedId;
        if (box && box.dataset.sig === sig) return;   // unverändert: nicht neu aufbauen
        if (!box) { box = document.createElement('div'); box.className = 'wh-vault'; box.dataset.for = '1'; anchor.parentNode.insertBefore(box, anchor); }
        box.querySelectorAll('img').forEach((i) => URL.revokeObjectURL(i.src));
        box.dataset.sig = sig;
        box.innerHTML = '';
        const head = document.createElement('div'); head.className = 'wh-vault__head';
        const label = document.createElement('span'); label.textContent = usedId ? 'Dein Foto ist eingesetzt' : 'Deine Fotos';
        if (usedId) label.className = 'wh-vault__ok';
        const clr = document.createElement('button'); clr.type = 'button'; clr.className = 'wh-vault__clear'; clr.textContent = 'Löschen';
        clr.addEventListener('click', clear); head.append(label, clr); box.appendChild(head);
        const ul = document.createElement('ul'); ul.className = 'wh-vault__list';
        list.forEach((p) => {
          const li = document.createElement('li');
          const b = document.createElement('button'); b.type = 'button'; b.className = 'wh-vault__pick' + (p.id === usedId ? ' is-used' : ''); b.setAttribute('aria-label', 'Foto ' + p.name + ' verwenden');
          const img = document.createElement('img'); img.alt = ''; img.src = URL.createObjectURL(p.blob);
          const tag = document.createElement('span'); tag.textContent = p.id === usedId ? 'Aktiv' : 'Verwenden';
          b.append(img, tag); b.addEventListener('click', async () => { usedId = p.id; await useFile(input, p); render(); });
          li.appendChild(b); ul.appendChild(li);
        });
        box.appendChild(ul);
        const small = document.createElement('p'); small.className = 'wh-vault__small'; small.style.margin = '0';
        small.textContent = list.some((p) => !p.keep)
          ? 'In Deinem Browser auf diesem Gerät, 3 Stunden ab der letzten Nutzung.'
          : 'In Deinem Browser auf diesem Gerät gespeichert, bis Du es löschst.';
        box.appendChild(small);
      });
    };

    // Auf der Produktseite fragen (Einwilligung per Klick, legal-check 2026-10-19 Variante B): „3 Stunden merken“,
    // „Dauerhaft merken“ oder „Nein, danke“. Automatisch nur im Overlay (von der Kundin für weitere Designs geöffnet).
    const ASKED = 'wh-vault-asked';
    const notice = (input, file) => {
      const anchor = anchorOf(input); if (!anchor || !anchor.parentNode) return;
      if (anchor.parentNode.querySelector(':scope > .wh-vault__note')) return;
      try { if (sessionStorage.getItem(ASKED) === '1') return; } catch (e) {}
      const note = document.createElement('div'); note.className = 'wh-vault wh-vault__note';
      note.innerHTML = '<strong>Noch ein Bild geplant?</strong><span>Wir können Dein Foto in Deinem Browser auf diesem Gerät merken. So setzt Du es beim nächsten Design mit einem Tipp ein, ohne es neu hochzuladen.</span>';
      const actions = document.createElement('div'); actions.className = 'wh-vault__actions';
      const visit = document.createElement('button'); visit.type = 'button'; visit.className = 'wh-vault__save'; visit.textContent = '3 Stunden merken';
      visit.addEventListener('click', async () => { usedId = await save(file, false); note.remove(); render(); });
      const keep = document.createElement('button'); keep.type = 'button'; keep.className = 'wh-vault__link'; keep.textContent = 'Dauerhaft merken';
      keep.addEventListener('click', async () => { ls(OPT, '1'); usedId = await save(file, true); await keepAll(); note.remove(); render(); });
      const no = document.createElement('button'); no.type = 'button'; no.className = 'wh-vault__link'; no.textContent = 'Nein, danke';
      no.addEventListener('click', () => { try { sessionStorage.setItem(ASKED, '1'); } catch (e) {} note.remove(); });
      actions.append(visit, keep, no);
      const small = document.createElement('span'); small.className = 'wh-vault__small';
      small.textContent = 'Das Merken selbst überträgt nichts an uns. Dauerhaft heißt: auch weitere Fotos auf diesem Gerät, bis Du auf „Löschen“ tippst. Auf gemeinsam genutzten Geräten besser nicht merken.';
      note.append(actions, small);
      anchor.parentNode.insertBefore(note, anchor.nextSibling);
    };

    document.addEventListener('change', async (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'file' || !input.closest('main')) return;
      if (input.__whFromVault) { input.__whFromVault = false; return; }
      const file = input.files && input.files[0];
      if (!file || !file.type.startsWith('image/')) return;
      if (optedIn()) { usedId = await save(file, true); render(); return; }
      // Im Overlay (weitere Designs) neues Foto für 3 Stunden übernehmen, wenn die Kundin schon gemerkt hat
      if (autoApply && (await all()).length) { usedId = await save(file, false); render(); return; }
      notice(input, file);
    }, true);

    // Im Overlay: zuletzt genutztes Foto einmal automatisch einsetzen, sobald das Upload-Feld da ist
    let applied = false;
    const tryAutoApply = async () => {
      if (!autoApply || applied) return;
      const input = inputs()[0];
      if (!input || (input.files && input.files.length)) return;
      const list = await all();
      if (!list.length) { applied = true; return; }
      applied = true;
      usedId = list[0].id;
      await useFile(input, list[0]);
      render();
    };

    // Neu zeichnen, wenn der Personalisierer Felder nachlädt; eigene Änderungen (.wh-vault) ignorieren
    let t; const obs = new MutationObserver((muts) => {
      if (muts.every((m) => m.target.closest && m.target.closest('.wh-vault'))) return;
      clearTimeout(t); t = setTimeout(() => { render(); tryAutoApply(); }, 300);
    });
    const start = async () => { await purge(); render(); tryAutoApply(); obs.observe(document.querySelector('main') || document.body, { childList: true, subtree: true }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    window.whVault = { all, clear };
  })();
